import React, { Component } from "react";
import AdminSummaryList from "./AdminSummaryList";
import AdminOrderList from "./AdminOrderList";
import moment from "moment";
import "react-lazy-load-image-component/src/effects/blur.css";
import ReactToPrint from "react-to-print";
import "./poPrint.css";
import numeral from "numeral";

class AdminGrid extends Component {
  state = {
    selectedOrders: true,
    allOrders: false,
    messageFocus: false,
    compactOrderView: false,
    viewOpenOrders: true,
    print1OrderView: true,
    showFilters: true,
    data: {
      path: "adminSummary",
      payload: {
        targetDeliveryDate: moment()
          .format("ddd DD-MM-YYYY")
          .toString(),
        deliveryDate: moment()
          .subtract(1, "day")
          .format("DD-MM-YYYY")
          .toString(),
        open: true,
        delivered: false,
        sTgtdFlagDate: true,
        orderDateFlag: false,
        allItems: true,
        foodItems: false,
        vfruitItems: false,
        meatItems: false,
        ingredients: false,
        mealLunch: true,
        mealDinner: true,
        mealAll: true,
        image: true
      }
    }
  };

  componentDidMount() {
    this.setState(prevState => {
      return {
        ...prevState,
        compactOrderView: false,
        data: {
          path: "adminSummary",
          payload: {
            targetDeliveryDate: moment()
              .format("ddd DD-MM-YYYY")
              .toString(),
            deliveryDate: moment()
              .subtract(1, "day")
              .format("DD-MM-YYYY")
              .toString(),
            open: true,
            delivered: false,
            sTgtdFlagDate: true,
            orderDateFlag: false,
            allItems: true,
            foodItems: false,
            vfruitItems: false,
            meatItems: false,
            ingredients: false,
            mealLunch: true,
            mealDinner: true,
            mealAll: true,
            breakup: true,
            image: true
          }
        }
      };
    });
    this.getSummedData(this.props.data);
    this.getOrdCount(this.props.data);
  }

  getOrdCount = data => {
    let procInfo = _.chain(data)
      .groupBy("mobile")
      .map(function(value, key) {
        if (value.length > 0) {
          return {
            mobile: key,
            dates: _.pluck(value, "deliveryDate"),
            createDates: _.pluck(value, "createDateTime"),
            count: value.length
          };
        }
      })
      .compact()
      .value();
    let finalInfo = {};
    for (let i = 0; i < procInfo.length; i++) {
      finalInfo[procInfo[i]["mobile"]] = procInfo[i];
    }
    this.stateChangeHandler(finalInfo, "finalInfo", false, true);
  };

  /*
 summedData: this.getSummedData(this.props.data),
        procInfo: this.getProcInfo(this.props.data)
  */
  getProcInfo = recs => {
    let data = _.cloneDeep(recs);
    //console.log(moment().format("x") + " starting chaining");
    let procInfo = _.chain(recs)
      .filter(item => {
        let sdDate = moment(this.state.data.payload.deliveryDate, "DD-MM-YYYY");
        let dDate = moment(item.deliveryDate, "DD-MM-YYYY");
        if (item.createDateTime && item.createDateTime !== "") {
          if (item.createDateTime.includes("/")) {
            dDate = moment(item.createDateTime, "DD/MM/YYYY hh:mm:ss");
          } else {
            dDate = moment(item.createDateTime, "ddd DD-MM-YY h:mm a");
          }
        }

        let tgtdDate = moment(item.targetDeliveryDate, "ddd DD-MM-YYYY");
        let sTgtdDate = moment(
          this.state.data.payload.targetDeliveryDate,
          "ddd DD-MM-YYYY"
        );

        let res = false;
        // sTgtdFlagDate: false,
        //   orderDateFlag: true
        if (
          (this.state.data.payload.orderDateFlag &&
            dDate.isSame(sdDate, "day")) ||
          (this.state.data.payload.sTgtdFlagDate &&
            tgtdDate.isSame(sTgtdDate, "day"))
        ) {
          if (
            this.state.data.payload.open &&
            !this.state.data.payload.delivered
          ) {
            if (item.status !== "CANCELLED" && item.status !== "DELIVERED") {
              res = true;
            }
          } else if (
            !this.state.data.payload.open &&
            this.state.data.payload.delivered
          ) {
            if (item.status === "DELIVERED") {
              res = true;
            }
          } else if (
            this.state.data.payload.open &&
            this.state.data.payload.delivered
          ) {
            if (item.status !== "CANCELLED") {
              res = true;
            }
          }
        }
        //if (item.targetDeliveryDate.includes("17-01-2021")) {
        // console.log(
        //   "Result: " +
        //     res +
        //     " order: " +
        //     item.targetDeliveryDate +
        //     " vs stateTgt: " +
        //     this.state.data.payload.targetDeliveryDate +
        //     " & stateODate: " +
        //     this.state.data.payload.deliveryDate +
        //     " byOrderDate: " +
        //     this.state.data.payload.orderDateFlag +
        //     " byDeliveryDate: " +
        //     this.state.data.payload.sTgtdFlagDate
        // );
        // console.log(
        //   tgtdDate + "|" + sTgtdDate + "|" + tgtdDate.isSame(sTgtdDate, "day")
        // );
        //}
        return res;
      })
      .filter(item => {
        let res = false;
        if (this.state.data.payload.mealLunch) {
          if (item.mealType && item.mealType === "LUNCH") {
            res = true;
          }
        }
        if (this.state.data.payload.mealDinner) {
          if (item.mealType && item.mealType === "DINNER") {
            res = true;
          }
        }
        if (this.state.data.payload.mealAll) {
          res = true;
        }
        return res;
      })
      .filter(itemOrd => {
        //console.log("finding categ orders");
        if (this.state.data.payload.allItems) {
          //console.log("all items");
          return true;
        } else if (this.state.data.payload.foodItems) {
          //console.log("food only " + itemOrd.requestedItems.length);
          for (let k = 0; k < itemOrd.requestedItems.length; k++) {
            let item = itemOrd.requestedItems[k];
            //console.log("item cag: " + item.category);
            if (item.category && item.category.includes("রান্না করা খাবার")) {
              k = itemOrd.requestedItems.length + 1;
              return true;
            }
          }
        } else if (this.state.data.payload.vfruitItems) {
          //console.log("veg only");
          for (let k = 0; k < itemOrd.requestedItems.length; k++) {
            let item = itemOrd.requestedItems[k];

            if (item.category && item.category.includes("FRUITS VEGET")) {
              k = itemOrd.requestedItems.length + 1;
              return true;
            }
          }
        } else if (this.state.data.payload.meatItems) {
          //console.log("meat only");
          for (let k = 0; k < itemOrd.requestedItems.length; k++) {
            let item = itemOrd.requestedItems[k];

            if (item.category && item.category.includes("MEAT FISH")) {
              k = itemOrd.requestedItems.length + 1;
              return true;
            }
          }
        } else if (this.state.data.payload.ingredients) {
          //console.log("in gredients");
          for (let k = 0; k < itemOrd.requestedItems.length; k++) {
            let item = itemOrd.requestedItems[k];

            if (
              item.category &&
              !item.category.includes("রান্না করা খাবার") &&
              !item.category.includes("FRUITS VEGETA") &&
              !item.category.includes("MEAT FISH")
            ) {
              k = itemOrd.requestedItems.length + 1;
              return true;
            }
          }
        }
      })
      .value();
    return procInfo;
  };

  getSummedData = recs => {
    //console.log(recs.length);

    //let procInfo = _.groupBy(data, "mobile");
    // console.log(JSON.stringify(Object.keys(procInfo)));
    // console.log("rara ==> started");
    function sum(numbers) {
      //console.log(JSON.stringify(numbers));
      let numSum = _.reduce(
        numbers,
        function(result, current) {
          //console.log("current: " + current + "  result: " + result);
          if (
            current === "" ||
            current === null ||
            current === undefined ||
            current === "NaN"
          ) {
            console.log("Found an NaN===" + current);
            current = 0;
          }
          return result + parseFloat(current);
        },
        0
      );
      //console.log(numSum);
      return numSum;
    }
    if (
      this.state.data.payload.targetDeliveryDate &&
      this.state.data.payload.targetDeliveryDate !== undefined
    ) {
      let procInfo = _.cloneDeep(this.getProcInfo(recs));
      this.stateChangeHandler(procInfo, "procInfo", false, true);
      let sumArray = [];
      for (let i = 0; i < procInfo.length; i++) {
        let currOrd = procInfo[i];
        let currProds = currOrd.requestedItems;
        if (currProds && currProds.length > 0) {
          for (let j = 0; j < currProds.length; j++) {
            currProds[j]["ordererName"] = currOrd.name;
            currProds[j]["ordererMobile"] = currOrd.mobile;
            sumArray.push(currProds[j]);
          }
        }
      }
      //console.log(JSON.stringify(sumArray));
      let summedProds = _.chain(sumArray)
        .groupBy("productNameEnglish")
        .map((value, key) => {
          return {
            productName: key,
            totalQuantity: sum(_.pluck(value, "quantity")),
            qtyGroups: _.chain(_.pluck(value, "quantity"))
              .countBy()
              .map((val, k) => {
                return { bucketSize: k, bucketFrequency: val };
              })
              .value(),
            unit: _.pluck(value, "unit"),
            price: parseFloat(
              (parseFloat(_.pluck(value, "productPrice")[0]) * 0.9).toFixed(2)
            ),
            totAmount:
              sum(_.pluck(value, "quantity")) *
              parseFloat(_.pluck(value, "productPrice")[0]) *
              0.9,
            name: _.pluck(value, "ordererName"),
            mobile: _.pluck(value, "ordererMobile"),
            subQuantities: _.pluck(value, "quantity"),
            photos: value[0].photos,
            category: value[0].category
          };
        }, 0)
        .filter(item => {
          let res2 = false;
          if (this.state.data.payload.allItems) {
            res2 = true;
          }
          if (
            this.state.data.payload.foodItems &&
            item.category &&
            item.category.includes("রান্না করা খাবার")
          ) {
            res2 = true;
          }
          if (
            this.state.data.payload.vfruitItems &&
            item.category &&
            item.category.includes("FRUITS VEGET")
          ) {
            res2 = true;
          }
          if (
            this.state.data.payload.meatItems &&
            item.category &&
            item.category.includes("MEAT FISH")
          ) {
            res2 = true;
          }
          if (
            this.state.data.payload.ingredients &&
            item.category &&
            !item.category.includes("রান্না করা খাবার") &&
            !item.category.includes("FRUITS VEGETA") &&
            !item.category.includes("MEAT FISH")
          ) {
            res2 = true;
          }
          return res2;
        })
        .sortBy("totalQuantity")
        .reverse()
        .value();
      //console.log(JSON.stringify(summedProds));
      //return { products: summedProds, ordCount: procInfo.length };
      let ordTotal = 0;
      for (let i = 0; i < procInfo.length; i++) {
        ordTotal =
          ordTotal +
          sum(
            _.chain(procInfo[i].requestedItems)
              .filter(item => {
                let res2 = false;
                if (this.state.data.payload.allItems) {
                  res2 = true;
                }
                if (
                  this.state.data.payload.foodItems &&
                  item.category &&
                  item.category.includes("রান্না করা খাবার")
                ) {
                  res2 = true;
                }
                if (
                  this.state.data.payload.vfruitItems &&
                  item.category &&
                  item.category.includes("FRUITS VEGET")
                ) {
                  res2 = true;
                }
                if (
                  this.state.data.payload.meatItems &&
                  item.category &&
                  item.category.includes("MEAT FISH")
                ) {
                  res2 = true;
                }
                if (
                  this.state.data.payload.ingredients &&
                  item.category &&
                  !item.category.includes("রান্না করা খাবার") &&
                  !item.category.includes("FRUITS VEGETA") &&
                  !item.category.includes("MEAT FISH")
                ) {
                  res2 = true;
                }
                return res2;
              })
              .pluck("amount")
              .value()
          );
      }
      //console.log(ordTotal);
      ordTotal = numeral(ordTotal).format("0,0.00");

      let locArray = _.chain(procInfo)
        .groupBy("address")
        .map((val, key) => key)
        .value();

      this.stateChangeHandler(
        {
          products: summedProds,
          ordCount: procInfo.length,
          ordTotal: ordTotal,
          locations: locArray.length
        },
        "summedData",
        false,
        true
      );
    } else {
      this.stateChangeHandler(
        { products: [], ordCount: 0 },
        "summedData",
        false,
        true
      );
    }
    //console.log("ended ==> started");
  };

  //single method that work for all fields
  //takes incoming id of the field and then adds field data to state
  stateChangeHandler = (val, id, isPayload, counterUpdate) => {
    //console.log("val: " + val + " id: " + id + " isPayload: " + isPayload);
    let tmpState = {};
    tmpState[id] = val;
    let calcFields = [
      "targetDeliveryDate",
      "deliveryDate",
      "allItems",
      "mealAll",
      "delivered"
    ];
    if (isPayload) {
      this.setState(
        prevState => {
          if (prevState && prevState.data.payload !== null) {
            return {
              ...prevState,
              data: {
                ...prevState.data,
                payload: {
                  ...prevState.data.payload,
                  ...tmpState
                }
              }
            };
          } else {
            return {
              ...prevState,
              data: {
                path: prevState.data.path,
                payload: {
                  ...tmpState
                }
              }
            };
          }
        },
        () => {
          if (!counterUpdate) {
            if (calcFields.includes(id)) {
              //console.log("the id is: " + id);
              this.getSummedData(this.props.data);
            }
          }
        }
      );
    } else {
      this.setState(
        prevState => {
          return {
            ...prevState,
            ...tmpState
          };
        },
        () => {
          if (!counterUpdate) {
            if (calcFields.includes(id)) {
              //console.log("the id is: " + id);
              this.getSummedData(this.props.data);
            }
          }
        }
      );
    }
  };

  getControlPanel = () => {
    return (
      <div
        style={{
          borderRadius: "10px",
          backgroundColor: "white",
          margin: "5px",
          padding: "10px",
          marginBottom: "15px",
          fontSize: "12px",
          fontWeight: "bold",
          border: "1.5px solid #ccc",
          boxSizing: "border-box",
          boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)"
        }}
      >
        <div
          style={{
            backgroundColor: "gainsboro"
          }}
        >
          <hr
            style={{
              margin: "2px"
            }}
          />
          {this.getDateFilter()}
          {this.getTargetDateFilter()}
          <hr
            style={{
              margin: "2px"
            }}
          />
          <div
            style={{
              fontSize: "12px",
              display: "flex",
              flexDirection: "row",
              padding: "5px"
            }}
          >
            <div
              style={{
                width: "33%",
                textAlign: "center",
                lineHeight: "20px",
                fontSize: this.state.data.payload.open ? "14px" : "10px"
              }}
              onClick={() => {
                this.stateChangeHandler(true, "open", true);
                this.stateChangeHandler(false, "delivered", true);
                this.stateChangeHandler(false, "all", true);
              }}
            >
              <span
                style={{
                  marginRight: "3px"
                }}
              >
                <icon
                  className={
                    this.state.data.payload.open
                      ? "fa fa-eye"
                      : "fa fa-eye-slash"
                  }
                  style={{ color: "rgb(30, 101, 144)" }}
                />{" "}
                OPEN
              </span>
            </div>

            <div
              style={{
                width: "34%",
                textAlign: "center",
                lineHeight: "20px",
                fontSize: this.state.data.payload.delivered ? "14px" : "10px"
              }}
              onClick={() => {
                this.stateChangeHandler(false, "open", true);
                this.stateChangeHandler(true, "delivered", true);
                this.stateChangeHandler(false, "all", true);
              }}
            >
              <span
                style={{
                  marginRight: "3px"
                }}
              >
                <icon
                  className={
                    this.state.data.payload.delivered
                      ? "fa fa-eye"
                      : "fa fa-eye-slash"
                  }
                  style={{ color: "rgb(30, 101, 144)" }}
                />{" "}
                DELIVERED
              </span>
            </div>

            <div
              style={{
                width: "33%",
                textAlign: "center",
                lineHeight: "20px",
                fontSize: this.state.data.payload.all ? "14px" : "10px"
              }}
              onClick={() => {
                this.stateChangeHandler(true, "open", true);
                this.stateChangeHandler(true, "delivered", true);
                this.stateChangeHandler(true, "all", true);
              }}
            >
              <span
                style={{
                  marginRight: "3px"
                }}
              >
                <icon
                  className={
                    this.state.data.payload.all
                      ? "fa fa-eye"
                      : "fa fa-eye-slash"
                  }
                  style={{ color: "rgb(30, 101, 144)" }}
                />{" "}
                ALL
              </span>
            </div>
          </div>
          <hr
            style={{
              margin: "2px"
            }}
          />

          <div
            style={{
              fontSize: "12px",
              display: "flex",
              flexDirection: "row",
              padding: "5px"
            }}
          >
            {this.getCategCell(
              "allItems",
              "ALL",
              true,
              false,
              false,
              false,
              false
            )}
            {this.getCategCell(
              "foodItems",
              "FOOD",
              false,
              true,
              false,
              false,
              false
            )}
            {this.getCategCell(
              "vfruitItems",
              "VEG",
              false,
              false,
              true,
              false,
              false
            )}
            {this.getCategCell(
              "meatItems",
              "MEATS",
              false,
              false,
              false,
              true,
              false
            )}
            {this.getCategCell(
              "ingredients",
              "DRY",
              false,
              false,
              false,
              false,
              true
            )}
          </div>
          <hr
            style={{
              margin: "2px"
            }}
          />

          <div
            style={{
              fontSize: "12px",
              display: "flex",
              flexDirection: "row",
              padding: "5px"
            }}
          >
            <div
              style={{
                width: "50%",
                textAlign: "center",
                lineHeight: "20px",
                fontSize: this.state.data.payload.breakup ? "14px" : "10px"
              }}
              onClick={() => {
                this.stateChangeHandler(true, "breakup", true);
              }}
            >
              <span
                style={{
                  marginRight: "3px"
                }}
              >
                <icon
                  className={
                    this.state.data.payload.breakup
                      ? "fa fa-eye"
                      : "fa fa-eye-slash"
                  }
                  style={{ color: "rgb(30, 101, 144)" }}
                />{" "}
                SHOW BREAKUP
              </span>
            </div>

            <div
              style={{
                width: "50%",
                textAlign: "center",
                lineHeight: "20px",
                fontSize: !this.state.data.payload.breakup ? "14px" : "10px"
              }}
              onClick={() => {
                this.stateChangeHandler(false, "breakup", true);
              }}
            >
              <span
                style={{
                  marginRight: "3px"
                }}
              >
                <icon
                  className={
                    !this.state.data.payload.breakup
                      ? "fa fa-eye"
                      : "fa fa-eye-slash"
                  }
                  style={{ color: "rgb(30, 101, 144)" }}
                />{" "}
                HIDE BREAKUP
              </span>
            </div>
          </div>
          <hr
            style={{
              margin: "2px"
            }}
          />

          <div
            style={{
              fontSize: "12px",
              display: "flex",
              flexDirection: "row",
              padding: "5px"
            }}
          >
            <div
              style={{
                width: "33%",
                textAlign: "center",
                lineHeight: "20px",
                fontSize: this.state.data.payload.mealLunch ? "14px" : "10px"
              }}
              onClick={() => {
                this.stateChangeHandler(true, "mealLunch", true);
                this.stateChangeHandler(false, "mealDinner", true);
                this.stateChangeHandler(false, "mealAll", true);
              }}
            >
              <span
                style={{
                  marginRight: "3px"
                }}
              >
                <icon
                  className={
                    this.state.data.payload.mealLunch
                      ? "fa fa-eye"
                      : "fa fa-eye-slash"
                  }
                  style={{ color: "rgb(30, 101, 144)" }}
                />{" "}
                LUNCH
              </span>
            </div>

            <div
              style={{
                width: "34%",
                textAlign: "center",
                lineHeight: "20px",
                fontSize: this.state.data.payload.mealDinner ? "14px" : "10px"
              }}
              onClick={() => {
                this.stateChangeHandler(false, "mealLunch", true);
                this.stateChangeHandler(true, "mealDinner", true);
                this.stateChangeHandler(false, "mealAll", true);
              }}
            >
              <span
                style={{
                  marginRight: "3px"
                }}
              >
                <icon
                  className={
                    this.state.data.payload.mealDinner
                      ? "fa fa-eye"
                      : "fa fa-eye-slash"
                  }
                  style={{ color: "rgb(30, 101, 144)" }}
                />{" "}
                DINNER
              </span>
            </div>

            <div
              style={{
                width: "33%",
                textAlign: "center",
                lineHeight: "20px",
                fontSize: this.state.data.payload.mealAll ? "14px" : "10px"
              }}
              onClick={() => {
                this.stateChangeHandler(true, "mealLunch", true);
                this.stateChangeHandler(true, "mealDinner", true);
                this.stateChangeHandler(true, "mealAll", true);
              }}
            >
              <span
                style={{
                  marginRight: "3px"
                }}
              >
                <icon
                  className={
                    this.state.data.payload.mealAll
                      ? "fa fa-eye"
                      : "fa fa-eye-slash"
                  }
                  style={{ color: "rgb(30, 101, 144)" }}
                />{" "}
                ALL
              </span>
            </div>
          </div>
          <hr
            style={{
              margin: "2px"
            }}
          />

          <div
            style={{
              fontSize: "12px",
              display: "flex",
              flexDirection: "row",
              padding: "5px"
            }}
          >
            <div
              style={{
                width: "50%",
                textAlign: "center",
                lineHeight: "20px",
                fontSize: this.state.data.payload.image ? "14px" : "10px"
              }}
              onClick={() => {
                this.stateChangeHandler(true, "image", true);
              }}
            >
              <span
                style={{
                  marginRight: "3px"
                }}
              >
                <icon
                  className={
                    this.state.data.payload.image
                      ? "fa fa-eye"
                      : "fa fa-eye-slash"
                  }
                  style={{ color: "rgb(30, 101, 144)" }}
                />{" "}
                SHOW IMAGE
              </span>
            </div>

            <div
              style={{
                width: "50%",
                textAlign: "center",
                lineHeight: "20px",
                fontSize: !this.state.data.payload.image ? "14px" : "10px"
              }}
              onClick={() => {
                this.stateChangeHandler(false, "image", true);
              }}
            >
              <span
                style={{
                  marginRight: "3px"
                }}
              >
                <icon
                  className={
                    !this.state.data.payload.image
                      ? "fa fa-eye"
                      : "fa fa-eye-slash"
                  }
                  style={{ color: "rgb(30, 101, 144)" }}
                />{" "}
                HIDE IMAGE
              </span>
            </div>
          </div>
          <hr
            style={{
              margin: "2px"
            }}
          />
          <div
            style={{
              fontSize: "12px",
              display: "flex",
              flexDirection: "row",
              padding: "5px"
            }}
          >
            <div
              style={{
                width: "50%",
                textAlign: "center",
                lineHeight: "20px",
                fontSize: this.state.data.payload.poMode ? "14px" : "10px"
              }}
              onClick={() => {
                this.stateChangeHandler(true, "poMode", true);
              }}
            >
              <span
                style={{
                  marginRight: "3px"
                }}
              >
                <icon
                  className={
                    this.state.data.payload.poMode
                      ? "fa fa-eye"
                      : "fa fa-eye-slash"
                  }
                  style={{ color: "rgb(30, 101, 144)" }}
                />{" "}
                PO View
              </span>
            </div>

            <div
              style={{
                width: "50%",
                textAlign: "center",
                lineHeight: "20px",
                fontSize: !this.state.data.payload.poMode ? "14px" : "10px"
              }}
              onClick={() => {
                this.stateChangeHandler(false, "poMode", true);
              }}
            >
              <span
                style={{
                  marginRight: "3px"
                }}
              >
                <icon
                  className={
                    !this.state.data.payload.poMode
                      ? "fa fa-eye"
                      : "fa fa-eye-slash"
                  }
                  style={{ color: "rgb(30, 101, 144)" }}
                />{" "}
                BCS View
              </span>
            </div>
          </div>
          <hr
            style={{
              margin: "2px"
            }}
          />
        </div>
      </div>
    );
  };

  getDateFilter = () => {
    return (
      <div
        style={{
          display: "flex",
          direction: "row",
          alignItems: "center"
        }}
      >
        <div
          style={{
            fontSize: "14px",
            border: "0px solid black",
            cursor: "pointer",
            width: "250px",
            height: "30px",
            lineHeight: "30px",
            textAlign: "left",
            margin: "5px",
            marginLeft: "15px",
            marginRight: "15px"
          }}
          onClick={() => {
            this.stateChangeHandler(
              !this.state.data.payload.orderDateFlag,
              "orderDateFlag",
              true
            );
            this.stateChangeHandler(
              !this.state.data.payload.sTgtdFlagDate,
              "sTgtdFlagDate",
              true
            );
          }}
        >
          <span
            style={{
              marginRight: "3px"
            }}
          >
            <icon
              className={
                this.state.data.payload.orderDateFlag
                  ? "fa fa-eye"
                  : "fa fa-eye-slash"
              }
              style={{ color: "rgb(30, 101, 144)" }}
            />{" "}
            Order Date
          </span>
        </div>
        <div
          style={{
            borderRadius: "5px",
            color: "#fff",
            backgroundColor: "rgb(30, 101, 144)",
            fontSize: "1.5em",
            border: "0px solid black",
            cursor: "pointer",
            fontWeight: "bold",
            width: "60px",
            height: "30px",
            lineHeight: "30px",
            textAlign: "center",
            margin: "5px",
            marginLeft: "15px"
          }}
          onClick={() => {
            let currStateDate = this.state.data.payload.deliveryDate;
            if (!currStateDate || currStateDate === undefined) {
              currStateDate = moment().format("DD-MM-YYYY");
            }
            let currTgtDate = moment(currStateDate, "DD-MM-YYYY");
            let newDate = currTgtDate.subtract(1, "day");

            this.stateChangeHandler(
              newDate.format("DD-MM-YYYY").toString(),
              "deliveryDate",
              true
            );
            this.stateChangeHandler(true, "orderDateFlag", true);
            this.stateChangeHandler(false, "sTgtdFlagDate", true);
          }}
        >
          {"<"}
        </div>
        <div
          style={{
            width: "100%",
            lineHeight: "45px",
            textAlign: "center"
          }}
        >
          {moment(this.state.data.payload["deliveryDate"], "DD-MM-YYYY")
            .format("ddd DD-MM-YYYY")
            .toString()}
        </div>
        <div
          style={{
            borderRadius: "5px",
            color: "#fff",
            backgroundColor: "rgb(30, 101, 144)",
            fontSize: "1.5em",
            border: "0px solid black",
            cursor: "pointer",
            fontWeight: "bold",
            width: "60px",
            height: "30px",
            lineHeight: "30px",
            textAlign: "center",
            margin: "5px",
            marginRight: "15px"
          }}
          onClick={() => {
            let currTgtDate = moment(
              this.state.data.payload.deliveryDate,
              "DD-MM-YYYY"
            );
            let newDate = currTgtDate.add(1, "day");

            if (this.state.data.payload.deliveryDate) {
              this.stateChangeHandler(
                newDate.format("DD-MM-YYYY").toString(),
                "deliveryDate",
                true
              );
            } else {
              this.stateChangeHandler(
                moment()
                  .add(1, "day")
                  .format("DD-MM-YYYY")
                  .toString(),
                "deliveryDate",
                true
              );
            }
            this.stateChangeHandler(true, "orderDateFlag", true);
            this.stateChangeHandler(false, "sTgtdFlagDate", true);
          }}
        >
          {">"}
        </div>
      </div>
    );
  };

  getTargetDateFilter = () => {
    return (
      <div
        style={{
          display: "flex",
          direction: "row",
          alignItems: "center"
        }}
      >
        <div
          style={{
            fontSize: "14px",
            border: "0px solid black",
            cursor: "pointer",
            width: "250px",
            height: "30px",
            lineHeight: "30px",
            textAlign: "left",
            margin: "5px",
            marginLeft: "15px",
            marginRight: "15px"
          }}
          onClick={() => {
            this.stateChangeHandler(
              !this.state.data.payload.sTgtdFlagDate,
              "sTgtdFlagDate",
              true
            );
            this.stateChangeHandler(
              !this.state.data.payload.orderDateFlag,
              "orderDateFlag",
              true
            );
          }}
        >
          <span
            style={{
              marginRight: "3px"
            }}
          >
            <icon
              className={
                this.state.data.payload.sTgtdFlagDate
                  ? "fa fa-eye"
                  : "fa fa-eye-slash"
              }
              style={{ color: "rgb(30, 101, 144)" }}
            />
          </span>{" "}
          Tgt Dlvry Dt
        </div>
        <div
          style={{
            borderRadius: "5px",
            color: "#fff",
            backgroundColor: "rgb(30, 101, 144)",
            fontSize: "1.5em",
            border: "0px solid black",
            cursor: "pointer",
            fontWeight: "bold",
            width: "60px",
            height: "30px",
            lineHeight: "30px",
            textAlign: "center",
            margin: "5px",
            marginLeft: "15px"
          }}
          onClick={() => {
            let currStateDate = this.state.data.payload.targetDeliveryDate;
            if (!currStateDate || currStateDate === undefined) {
              currStateDate = moment().format("ddd DD-MM-YYYY");
            }
            let currTgtDate = moment(currStateDate, "ddd DD-MM-YYYY");
            let newDate = currTgtDate.subtract(1, "day");

            this.stateChangeHandler(
              newDate.format("ddd DD-MM-YYYY").toString(),
              "targetDeliveryDate",
              true
            );
            this.stateChangeHandler(true, "sTgtdFlagDate", true);
            this.stateChangeHandler(false, "orderDateFlag", true);
          }}
        >
          {"<"}
        </div>
        <div
          style={{
            width: "100%",
            lineHeight: "45px",
            textAlign: "center"
          }}
        >
          {this.state.data.payload["targetDeliveryDate"]}
        </div>
        <div
          style={{
            borderRadius: "5px",
            color: "#fff",
            backgroundColor: "rgb(30, 101, 144)",
            fontSize: "1.5em",
            border: "0px solid black",
            cursor: "pointer",
            fontWeight: "bold",
            width: "60px",
            height: "30px",
            lineHeight: "30px",
            textAlign: "center",
            margin: "5px",
            marginRight: "15px"
          }}
          onClick={() => {
            let currTgtDate = moment(
              this.state.data.payload.targetDeliveryDate,
              "ddd DD-MM-YYYY"
            );
            let newDate = currTgtDate.add(1, "day");

            if (this.state.data.payload.targetDeliveryDate) {
              this.stateChangeHandler(
                newDate.format("ddd DD-MM-YYYY").toString(),
                "targetDeliveryDate",
                true
              );
            } else {
              this.stateChangeHandler(
                moment()
                  .add(1, "day")
                  .format("ddd DD-MM-YYYY")
                  .toString(),
                "targetDeliveryDate",
                true
              );
            }
            this.stateChangeHandler(true, "sTgtdFlagDate", true);
            this.stateChangeHandler(false, "orderDateFlag", true);
          }}
        >
          {">"}
        </div>
      </div>
    );
  };

  getCategCell = (
    name,
    caption,
    allItems,
    foodItems,
    vfruitItems,
    meatItems,
    ingredients
  ) => {
    return (
      <div
        style={{
          width: "20%",
          textAlign: "center",
          lineHeight: "20px",
          fontSize: this.state.data.payload[name] ? "14px" : "10px"
        }}
        onClick={() => {
          this.stateChangeHandler(allItems, "allItems", true);
          this.stateChangeHandler(foodItems, "foodItems", true);
          this.stateChangeHandler(vfruitItems, "vfruitItems", true);
          this.stateChangeHandler(meatItems, "meatItems", true);
          this.stateChangeHandler(ingredients, "ingredients", true);
        }}
      >
        <span
          style={{
            marginRight: "3px"
          }}
        >
          <icon
            className={
              this.state.data.payload[name] ? "fa fa-eye" : "fa fa-eye-slash"
            }
            style={{ color: "rgb(30, 101, 144)" }}
          />{" "}
          {caption}
        </span>
      </div>
    );
  };

  getCounters = () => {
    return (
      <div
        style={{
          height: "45px",
          lineHeight: "45px",
          textAlign: "center"
        }}
      >
        {this.state.allOrders && (
          <div>Total Orders: {this.props.data.length}</div>
        )}
        {this.state.selectedOrders && (
          <div>
            Ords:{" "}
            {this.state.summedData && this.state.summedData.ordCount
              ? this.state.summedData.ordCount
              : "0"}{" "}
            | Prods:{" "}
            {this.state.summedData && this.state.summedData.products
              ? this.state.summedData.products.length
              : "0"}{" "}
            | Locs:{" "}
            {this.state.summedData && this.state.summedData.locations
              ? this.state.summedData.locations
              : " "}
            {this.props.cellPhone === "+6594562455" && (
              <span>
                | Amt:{" "}
                {this.state.summedData && this.state.summedData.ordTotal
                  ? this.state.summedData.ordTotal
                  : " "}
              </span>
            )}
          </div>
        )}
      </div>
    );
  };

  render() {
    return (
      <div
        style={{
          marginBottom: "15px"
        }}
      >
        <div
          style={{
            display: "flex",
            direction: "row"
          }}
        >
          <div
            style={{
              margin: "2px",
              padding: "2px",
              background: this.state.showSummary
                ? "rgb(30, 101, 144)"
                : "white",
              color: this.state.showSummary ? "white" : "black",
              textAlign: "center",
              width: "20%"
            }}
            onClick={() => {
              this.stateChangeHandler(
                !this.state.showSummary,
                "showSummary",
                false
              );
            }}
          >
            Smry
          </div>
          <div
            style={{
              margin: "2px",
              padding: "2px",
              background: this.state.showFilters
                ? "rgb(30, 101, 144)"
                : "white",
              color: this.state.showFilters ? "white" : "black",
              textAlign: "center",
              width: "20%"
            }}
            onClick={() => {
              this.stateChangeHandler(
                !this.state.showFilters,
                "showFilters",
                false
              );
            }}
          >
            Fltrs
          </div>

          <div
            style={{
              margin: "2px",
              padding: "2px",
              background: this.state.selectedOrders
                ? "rgb(30, 101, 144)"
                : "white",
              color: this.state.selectedOrders ? "white" : "black",
              textAlign: "center",
              width: "20%"
            }}
            onClick={() => {
              this.stateChangeHandler(
                !this.state.selectedOrders,
                "selectedOrders",
                false
              );
              this.stateChangeHandler(false, "allOrders", false);
            }}
          >
            Slctd Ord
          </div>
          <div
            style={{
              margin: "2px",
              padding: "2px",
              background: this.state.allOrders ? "rgb(30, 101, 144)" : "white",
              color: this.state.allOrders ? "white" : "black",
              textAlign: "center",
              width: "20%"
            }}
            onClick={() => {
              this.stateChangeHandler(
                !this.state.allOrders,
                "allOrders",
                false
              );
              this.stateChangeHandler(false, "selectedOrders", false);
            }}
          >
            All Ord
          </div>
          <div
            style={{
              margin: "2px",
              padding: "2px",
              background: this.state.messageFocus
                ? "rgb(30, 101, 144)"
                : "white",
              color: this.state.messageFocus ? "white" : "black",
              textAlign: "center",
              width: "20%"
            }}
            onClick={() => {
              this.stateChangeHandler(
                !this.state.messageFocus,
                "messageFocus",
                false
              );
              this.stateChangeHandler(false, "compactOrderView", false);
              this.stateChangeHandler(false, "regularOrderView", false);
              this.stateChangeHandler(false, "print1OrderView", false);
            }}
          >
            Msg Fcs
          </div>
        </div>

        <div
          style={{
            display: "flex",
            direction: "row"
          }}
        >
          <div
            style={{
              margin: "2px",
              padding: "2px",
              minWidth: "100px",
              background: this.state.regularOrderView
                ? "rgb(30, 101, 144)"
                : "white",
              color: this.state.regularOrderView ? "white" : "black",
              textAlign: "center",
              width: "20%"
            }}
            onClick={() => {
              this.stateChangeHandler(
                !this.state.regularOrderView,
                "regularOrderView",
                false
              );
              this.stateChangeHandler(false, "compactOrderView", false);
              this.stateChangeHandler(false, "messageFocus", false);
              this.stateChangeHandler(false, "print1OrderView", false);
            }}
          >
            Rglr
          </div>

          <div
            style={{
              margin: "2px",
              padding: "2px",
              background: this.state.compactOrderView
                ? "rgb(30, 101, 144)"
                : "white",
              color: this.state.compactOrderView ? "white" : "black",
              textAlign: "center",
              width: "20%"
            }}
            onClick={() => {
              this.stateChangeHandler(
                !this.state.compactOrderView,
                "compactOrderView",
                false
              );
              this.stateChangeHandler(false, "regularOrderView", false);
              this.stateChangeHandler(false, "messageFocus", false);
              this.stateChangeHandler(false, "print1OrderView", false);
            }}
          >
            Cmpct
          </div>

          <div
            style={{
              margin: "2px",
              padding: "2px",
              background: this.state.print1OrderView
                ? "rgb(30, 101, 144)"
                : "white",
              color: this.state.print1OrderView ? "white" : "black",
              textAlign: "center",
              width: "20%"
            }}
            onClick={() => {
              this.stateChangeHandler(
                !this.state.print1OrderView,
                "print1OrderView",
                false
              );
              this.stateChangeHandler(false, "compactOrderView", false);
              this.stateChangeHandler(false, "regularOrderView", false);
              this.stateChangeHandler(false, "messageFocus", false);
            }}
          >
            Prnt 1
          </div>
          <div
            style={{
              margin: "2px",
              padding: "2px",
              background: this.state.viewOpenOrders
                ? "rgb(30, 101, 144)"
                : "white",
              color: this.state.viewOpenOrders ? "white" : "black",
              textAlign: "center",
              width: "20%"
            }}
            onClick={() => {
              this.stateChangeHandler(
                !this.state.viewOpenOrders,
                "viewOpenOrders",
                false
              );
              this.stateChangeHandler(false, "viewAllOrders", false);
            }}
          >
            Open
          </div>
          <div
            style={{
              margin: "2px",
              padding: "2px",
              background: this.state.viewAllOrders
                ? "rgb(30, 101, 144)"
                : "white",
              color: this.state.viewAllOrders ? "white" : "black",
              textAlign: "center",
              width: "20%"
            }}
            onClick={() => {
              this.stateChangeHandler(
                !this.state.viewAllOrders,
                "viewAllOrders",
                false
              );
              this.stateChangeHandler(false, "viewOpenOrders", false);
            }}
          >
            All
          </div>
        </div>

        {this.state.showFilters && this.getControlPanel()}

        {this.state.showSummary && (
          <div>
            <div
              style={{
                margin: "5px",
                marginTop: "30px",
                textAlign: "center"
              }}
            >
              <ReactToPrint
                trigger={() => {
                  // NOTE: could just as easily return <SomeComponent />. Do NOT pass an `onClick` prop
                  // to the root node of the returned component as it will be overwritten.
                  return <a href="#">Print this out!</a>;
                }}
                content={() => this.summRef}
              />
            </div>

            <div ref={el => (this.summRef = el)}>
              {this.getCounters()}

              <AdminSummaryList
                {...this.props}
                summedData={this.state.summedData}
                //summedData={this.getSummedData(this.props.data)}
                image={this.state.data.payload.image}
                poMode={this.state.data.payload.poMode}
                breakup={this.state.data.payload.breakup}
                showImage={this.state.data.payload.image}
              />
            </div>
          </div>
        )}

        {this.state.allOrders && (
          <div>
            <div
              style={{
                margin: "5px",
                marginTop: "30px",
                textAlign: "center"
              }}
            >
              <ReactToPrint
                trigger={() => {
                  // NOTE: could just as easily return <SomeComponent />. Do NOT pass an `onClick` prop
                  // to the root node of the returned component as it will be overwritten.
                  return <a href="#">Print this out!</a>;
                }}
                content={() => this.allOrdRef}
              />
            </div>

            <div ref={el => (this.allOrdRef = el)}>
              <div style={{ overflowX: "auto" }}>
                {this.getCounters()}
                <AdminOrderList
                  {...this.props}
                  compact={this.state.compactOrderView}
                  regular={this.state.regularOrderView}
                  messageFocus={this.state.messageFocus}
                  printFocus={this.state.print1OrderView}
                  showDets={this.state.data.payload.breakup}
                  showImage={this.state.data.payload.image}
                  finalInfo={this.state.finalInfo}
                />
              </div>
            </div>
          </div>
        )}

        {this.state.selectedOrders && (
          <div>
            <div
              style={{
                margin: "5px",
                marginTop: "30px",
                textAlign: "center"
              }}
            >
              <ReactToPrint
                trigger={() => {
                  // NOTE: could just as easily return <SomeComponent />. Do NOT pass an `onClick` prop
                  // to the root node of the returned component as it will be overwritten.
                  return <a href="#">Print this out!</a>;
                }}
                content={() => this.selOrdRef}
              />
            </div>

            <div ref={el => (this.selOrdRef = el)}>
              <div>
                {this.getCounters()}
                <AdminOrderList
                  {...this.props}
                  data={this.getProcInfo(this.props.data)}
                  //data={this.getProcInfo(this.props.data)}
                  compact={this.state.compactOrderView}
                  regular={this.state.regularOrderView}
                  messageFocus={this.state.messageFocus}
                  printFocus={this.state.print1OrderView}
                  showDets={this.state.data.payload.breakup}
                  showImage={this.state.data.payload.image}
                  finalInfo={this.state.finalInfo}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default AdminGrid;



// WEBPACK FOOTER //
// ./src/app/components/Screens/ContentGrid/AdminGrid.jsx